// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__cgXfItQUqa{max-width:780px}`, "",{"version":3,"sources":["webpack://./src/components/conversation/conversationTimelineDetails/components/conversationLinkModal/conversationLinkModal.module.scss"],"names":[],"mappings":"AAAA,kBACE,eAAA","sourcesContent":[".root {\n  max-width: 780px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__cgXfItQUqa`
};
export default ___CSS_LOADER_EXPORT___;
